exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.address-box__selected[data-v-56c3a64e] {\n  background-color: rgba(0, 0, 0, .08);\n  border: 2px solid #ccc;\n}\n.address-box_un_selected[data-v-56c3a64e] {\n  border: 2px solid #ccc;\n}\n.btn-link[data-v-56c3a64e] {\n  color: #6c757d;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56c3a64e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/address/AddressDetails.vue
// module id = nuXj
// module chunks = 1